import React from 'react';
import DOMPurify from 'dompurify';
import { blogHtmlPurifyConfig } from '../../utils/blogDomPurifyConfig';

const formatDate = (dateStr) => {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  return d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
};

const getExcerpt = (html, maxLen = 160) => {
  if (!html || typeof html !== 'string') return '';
  const clean = DOMPurify.sanitize(html, blogHtmlPurifyConfig);
  const doc = new DOMParser().parseFromString(clean, 'text/html');
  const text = (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
  return text.length <= maxLen ? text : text.slice(0, maxLen).trim() + '…';
};

function BlogCard({ blog, featured = false, onReadMore }) {
  const slugOrId = blog.slug || blog.id;
  const handleOpen = () => {
    if (onReadMore) onReadMore(slugOrId, blog.title || '');
  };

  if (featured) {
    return (
      <article
        className="blog-featured"
        onClick={handleOpen}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleOpen();
          }
        }}
      >
        <div className="blog-featured-cover">
          {blog.cover_image ? (
            <img src={blog.cover_image} alt="" />
          ) : (
            <div className="blog-card-cover-placeholder" />
          )}
        </div>
        <div className="blog-featured-body">
          <time className="blog-featured-date">{formatDate(blog.updated_at || blog.created_at)}</time>
          <h2 className="blog-featured-title">{blog.title || 'Untitled'}</h2>
          <p className="blog-featured-excerpt">{getExcerpt(blog.content)}</p>
          <div className="blog-featured-meta">
            {blog.author && <span className="blog-author">By {blog.author}</span>}
            {blog.category && <span className="blog-category"> · {blog.category}</span>}
          </div>
        </div>
      </article>
    );
  }

  return (
    <article
      className="blog-card"
      onClick={handleOpen}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleOpen();
        }
      }}
    >
      <div className="blog-card-cover">
        {blog.cover_image ? (
          <img src={blog.cover_image} alt="" />
        ) : (
          <div className="blog-card-cover-placeholder" />
        )}
      </div>
      <div className="blog-card-body">
        <time className="blog-card-date">{formatDate(blog.updated_at || blog.created_at)}</time>
        <h2 className="blog-card-title">{blog.title || 'Untitled'}</h2>
        <div className="blog-card-meta">
          {blog.author && <span className="blog-author">{blog.author}</span>}
          {blog.category && <span className="blog-category"> · {blog.category}</span>}
        </div>
      </div>
    </article>
  );
}

export default BlogCard;
